import * as React from "react";
import { Box, Stack, Text } from "@origin-digital/ods-core";
import SidebarItem from "../SideBar/SidebarItem";
import ChangeRequestContext from "src/context/ChangeRequestContext";
import { RequestStatusEnum } from "src/components/Changes/types";
import { getElectricitySections } from "./helpers";
import { useParams } from "react-router-dom";

const ChangeRequestSideBarContent: React.FC = () => {
  const {
    premiseAddress,
    draftInfo,
    setActiveSection,
    sectionVisibility,
    activeSection,
  } = React.useContext(ChangeRequestContext);

  const isNew = draftInfo === null;
  const isDraft =
    draftInfo?.raw_request_status === RequestStatusEnum.DRAFT ||
    draftInfo?.raw_request_status === RequestStatusEnum.DRAFT_ASSIGNED;
  const isSubmitted = !isNew && !isDraft;

  const { requestId } = useParams<{ requestId: string }>();

  //set the active section based on the section that is currently in view
  React.useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id);
          }
        });
      },
      {
        rootMargin: "-50px 0px -80% 0px",
        threshold: 0,
      }
    );

    const sections = [
      "premiseSection",
      ...getElectricitySections({ isSubmitted, sectionVisibility }).map(
        (section) => section.id
      ),
    ];

    sections.forEach((sectionId) => {
      const element = document.getElementById(sectionId);
      if (element) {
        observer.observe(element);
      }
    });

    return () => {
      sections.forEach((sectionId) => {
        const element = document.getElementById(sectionId);
        if (element) {
          observer.unobserve(element);
        }
      });
    };
  }, [setActiveSection, sectionVisibility]);

  //scroll to a section
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 210;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.scrollY - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };
  return (
    <>
      {premiseAddress && (
        <Box
          width="full"
          paddingTop="medium"
          paddingBottom={{
            lg: "small",
            xs: "xsmall",
          }}
          paddingX="large"
        >
          <Stack space="xsmall">
            <Text>{premiseAddress}</Text>
          </Stack>
        </Box>
      )}
      {/* Nav links */}
      <Stack space="none">
        {requestId || !isNew ? (
          getElectricitySections({ isSubmitted, sectionVisibility })
            .filter(({ isVisible }) => isVisible)
            .map(({ name, id }) => (
              <SidebarItem
                key={id}
                name={name}
                id={id}
                onSelect={() => {
                  scrollToSection(id);
                  setActiveSection(id);
                }}
                activeSection={activeSection}
              />
            ))
        ) : (
          <SidebarItem
            name="Premises"
            id={"premiseSection"}
            onSelect={() => {
              scrollToSection("premiseSection");
              setActiveSection("premiseSection");
            }}
            activeSection={activeSection}
          />
        )}
      </Stack>
    </>
  );
};

export default ChangeRequestSideBarContent;
